import { render } from "./Frs.vue?vue&type=template&id=73fee71c&scoped=true"
import script from "./Frs.vue?vue&type=script&lang=js"
export * from "./Frs.vue?vue&type=script&lang=js"

import "./Frs.vue?vue&type=style&index=0&id=73fee71c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73fee71c"]])

export default __exports__